import { useParams } from "react-router-dom";
import { IFormSection, TSubmitType } from "../../types/common";
import { URL_ASSIGNED_TICKETS } from "../../utils/urls";
import { getRegister } from "../../utils/helpers";
import { INCIDENT_TICKETING_API } from "../../utils/apis";

export type TFormCustomProps = {
  id?: number;
  submitType?: TSubmitType;
};

export const useTicketClosureForm = () => {
  const { parent_id } = useParams<{ parent_id: string }>();

  const sections: IFormSection[] = [
    {
      title: "Ticket Closure",
      fields: [
        {
          field_name: "closure_comments",
          type: "textarea",
          label: "Closure Comments",
        },
      ],
    },
  ];

  const redirect = getRegister(URL_ASSIGNED_TICKETS);

  const onSubmit = (payload: any) => {
    return {
      api: `${INCIDENT_TICKETING_API}${parent_id}/close/`,
      params: payload,
      method: "POST",
    };
  };

  return { sections, redirect, onSubmit };
};

export function submitTicketClosure(payload: any, id: number | null) {
  return {
    api: `${INCIDENT_TICKETING_API}${id}/close/`,
    params: payload,
    method: "POST",
  };
}
